import { ContactPoint } from "models/Company";

type ContactPointListType = {
    phoneNumbers: ContactPoint[],
    mainContactPointId: string
}

export default function PhoneNumbersList({phoneNumbers,mainContactPointId}:ContactPointListType) {
  
    if(phoneNumbers.length === 0) {
        return (<tbody><tr><td colSpan={2}>Ingen nummer registrert</td></tr></tbody>)
    }

    const mainNumberIndex = phoneNumbers.findIndex(x => x.id === mainContactPointId);

    return (
        <tbody>
            { mainNumberIndex !== -1 ? <tr><th>Telefon hovednummer</th><td>{phoneNumbers[mainNumberIndex].value}</td></tr> : <tr><td colSpan={2}>Ingen hovednummer registrert</td></tr> }
            {phoneNumbers.map((cp: ContactPoint, index: number) => {
                if ( mainNumberIndex !== index && cp.findability !== false && cp.deleted === false) {
                    return (
                        <tr key={"contactpoint_" + index}>
                            <th>{cp.label}</th>
                            <td>{cp.value}</td>
                        </tr>
                    )
                }
                return null;
                }
            )}
        </tbody>
    );
}